import { Theme, ThemeOptions } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

export interface ExtendedTheme extends Theme {
  drawerWidth: number;
}

export interface ExtendedThemeOptions extends ThemeOptions {
  drawerWidth: number;
}

export const theme = createMuiTheme({
  drawerWidth: 240,
  palette: {
    primary: {
      main: '#282c34',
    },
    secondary: {
      main: '#112059',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        // overflowWrap: 'break-word',
        overflowWrap: 'break-word',
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'inherit',
        },
      },
    },
  },
} as ExtendedThemeOptions);
